"use client";
import { SingletonEnvironmentContext } from "./_private/useSingletonEnvironment.js";
import React from "react";
const useRTL = () => {
    return React.useContext(SingletonEnvironmentContext).rtl;
};
export default useRTL;
